module.exports = __webpack_public_path__ + "static/media/4.a7e98c45.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/4.png
// module id = 1200
// module chunks = 0